export default __webpack_public_path__ + "static/media/left.c8483f2d.svg";